import { ShipmentManagement } from "~/features/shipment-management/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const ShipmentManagementPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate(
		"traxLtlShipmentManagement",
	);

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <ShipmentManagement /> : <Construction />;
};
